<template>
  <div class="upload-lecture-video">
    <el-progress
      :class="uploadFlag ? 'show' : ''"
      :width="100"
      :percentage="uploadPercentage"
      status="success"
      class="process"
    ></el-progress>
    <el-upload
      class="pc-upload-file"
      accept=".mp4"
      action
      :one-third="false"
      :auto-upload="true"
      :show-file-list="false"
      :beforeUpload="beforeUpload"
      :http-request="uploadFile"
    >
      <p>上传视频</p>
    </el-upload>
  </div>
</template>

<script>
import { getOSSAuthWorksVideo_Api } from "@/apis/oss.api";
export default {
  data() {
    return {
      uploadPercentage: 0,
      uploadFlag: false,
      video_file:null,
    };
  },
  props: ["file", "title"],
  methods: {
    beforeUpload(file) {
      console.log("file", file);
        this.video_file = file;
    },
    async uploadFile() {
      if (!this.video_file) {
        this.$global.error(this, "请选择文件！", null);
        return;
      }
      this.uploadFlag = true;
      this.$emit("startUploadVideo");
      let result = await getOSSAuthWorksVideo_Api();
      let str = this.video_file.name.split(".");
      const that = this;
      console.log("au", result);
      if (result) {
        let file_name =
          result.base_path + str[0] + Date.parse(new Date()) + "." + str[1];
          console.log(  "http://wupen-doc.oss-cn-shanghai.aliyuncs.com/" + file_name)
        result.oss
          .multipartUpload(file_name, this.video_file, {
            progress: function (p) {
              //p进度条的值
              that.uploadPercentage = Math.floor(p * 100);
            },
          })
          .then((res) => {
            this.uploadFlag = false;
            let upload_url = res.res.requestUrls[0].split("?")[0];
            console.log("result", res.res.requestUrls[0].split("?")[0]);
            that.$global.success(that, "文件上传成功！", null);
            this.$emit("getUploadVideo", upload_url);
          })
          .catch((err) => {
            this.uploadFlag = false;
            console.log(err);
            this.$global.error(this, "文件上传失败！", null);
          });
      } else {
        this.$global.error(this, "服务器错误！", null);
        this.uploadFlag = false;
      }
    },
  },
};
</script>

<style scoped lang='scss'>
.upload-lecture-video {
    position:relative;
  .process {
    margin: 0 auto;
    opacity: 0;
    width:400px;
    height: 20px;
  }
  .show {
    opacity: 1;
  }
  .file-url {
    height: 36px;
  }
  .pc-upload-file {
      margin: 0 auto;
    width: 60px;
    height: 20px;
    cursor: pointer;
    text-align: center;
    border: 1px $timeBtn dashed;
    p {
      width: 60px;
      height: 20px;
      color: $timeBtn;
      line-height: 20px;
    }
    p:hover {
      background: $timeBtn;
      color: $base-color;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/componentSet/uploadVideo.vue